import template from './verify_2FA_code.html';
import controller from './verify_2FA_code.controller';
import './verify_2FA_code.scss';

let verify2FACodeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default verify2FACodeComponent;



// WEBPACK FOOTER //
// ./client/app/components/verify_2FA_code/verify_2FA_code.component.js